import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { isCommsOnly } from '../../../config/commsMode';

import css from './AuthMethodTabs.module.css';

/**
 * Sign up | Log in | Wallet Connect — single row of auth method tabs.
 */
const AuthMethodTabs = props => {
  const {
    isLogin,
    isWalletView,
    signupRouteName,
    userTypeMaybe,
    fromState,
  } = props;

  const routeName = isLogin ? 'LoginPage' : signupRouteName;
  const web2To = { ...fromState, search: undefined };
  const walletTo = { ...fromState, search: '?view=wallet' };
  const commsOnly = isCommsOnly();

  return (
    <nav className={css.root} aria-label="Authentication method">
      <NamedLink
        name={signupRouteName}
        params={userTypeMaybe}
        to={web2To}
        className={classNames(css.tab, !isLogin && !isWalletView ? css.tabActive : null)}
      >
        <FormattedMessage id="AuthenticationPage.signupLinkText" />
      </NamedLink>
      <NamedLink
        name="LoginPage"
        to={web2To}
        className={classNames(css.tab, isLogin && !isWalletView ? css.tabActive : null)}
      >
        <FormattedMessage id="AuthenticationPage.loginLinkText" />
      </NamedLink>
      <NamedLink
        name={routeName}
        params={userTypeMaybe}
        to={walletTo}
        className={classNames(css.tab, commsOnly ? css.tabOptional : null, isWalletView ? css.tabActive : null)}
      >
        <FormattedMessage
          id={
            commsOnly
              ? 'AuthenticationPage.walletLinkOptionalText'
              : 'AuthenticationPage.walletLinkText'
          }
        />
      </NamedLink>
    </nav>
  );
};

export default AuthMethodTabs;
